import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icons/vcicon.svg'


const _hoisted_1 = { class: "prodcelldiv" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "cellimage",
  alt: "vciconimg",
  title: "vciconimg"
}, null, -1)
const _hoisted_3 = { class: "celltext" }
const _hoisted_4 = { style: {"margin":"unset"} }
const _hoisted_5 = { style: {"font-weight":"700"} }
const _hoisted_6 = { class: "borrowcell" }
const _hoisted_7 = ["src", "alt", "title"]
const _hoisted_8 = { style: {"margin-left":"5px"} }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "expiration-cell" }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_table, {
    id: "assignedproductstable",
    data: _ctx.productsList,
    style: {"width":"100%"},
    "header-cell-style": _ctx.headerstyle,
    "row-style": _ctx.rowdatastyle,
    onSelectionChange: _ctx.handleSelectionChange,
    "cell-class-name": _ctx.checkExpirationDate,
    "empty-text": "No products assigned",
    "row-class-name": _ctx.getRowClassName
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        type: "selection",
        width: "55",
        selectable: _ctx.checkSelectable
      }, null, 8, ["selectable"]),
      _createVNode(_component_el_table_column, {
        label: "Assigned Products",
        prop: "productName"
      }, {
        default: _withCtx((props) => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, _toDisplayString(props.row.productName.substring(0, 18)), 1),
              _createElementVNode("label", _hoisted_5, _toDisplayString(props.row.productName.substring(18)), 1)
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        align: "center",
        label: "Version",
        width: "80"
      }, {
        default: _withCtx((props) => [
          _createTextVNode(_toDisplayString(props.row.majorVersionNumber) + "." + _toDisplayString(props.row.minorVersionNumber), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        align: "center",
        label: "License Type",
        prop: "licenseType"
      }),
      _createVNode(_component_el_table_column, {
        label: "Computer ID",
        prop: "computer"
      }),
      _createVNode(_component_el_table_column, {
        label: "Product Status",
        prop: "support",
        align: "center"
      }, {
        default: _withCtx((prod) => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: _ctx.getStatus(prod.row).icon,
              alt: _ctx.getStatus(prod.row).icon + 'iconimg',
              title: _ctx.getStatus(prod.row).icon + 'iconimg'
            }, null, 8, _hoisted_7),
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.getStatus(prod.row).label), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Add-on",
        align: "center",
        prop: "addOns"
      }, {
        default: _withCtx((props) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.addOns, (addon, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(addon.productName), 1))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Expiration Date",
        align: "center"
      }, {
        default: _withCtx((props) => [
          (_ctx.checkExpirationDate(props.row.expirationDateTime))
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                placement: "top"
              }, {
                content: _withCtx(() => [
                  (_ctx.expiringIn30Days)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createTextVNode(" The license has expired or is about to expire shortly. "),
                        _hoisted_10,
                        _createTextVNode("Please unassign the expired license and assign the new license. ")
                      ]))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(props.row.expirationDate), 1)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (!_ctx.checkExpirationDate(props.row.expirationDateTime))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(props.row.expirationDate), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Maintenance Renewal Date",
        prop: "maintenanceRenewalDateFormatted"
      })
    ]),
    _: 1
  }, 8, ["data", "header-cell-style", "row-style", "onSelectionChange", "cell-class-name", "row-class-name"])), [
    [_directive_loading, _ctx.loading]
  ])
}